import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Parser from 'html-react-parser';
import useToggle from '../../Hooks/useToggle';
import BackToTop from '../BackToTop';
// import Header from '../Helper/Header';
import Footer from '../Helper/FooterInstitute';
import Drawer from '../Mobile/DrawerInstitute';
import HeaderInstructor from './InstructorIndex_Insti';
import { IMGBASEAPIURL } from '../../config';
import './instructor.css';

function InstructorIndex() {
    const { t } = useTranslation();
    let InstHeadTitle = 'Fulfill Your Dream to Empower Learning with Acumen Glow';
    let InstHeadContent =
        'At Acumen Glow, we believe in the transformative power of education, and we are looking for passionate instructors like you to lead the way. If you are eager to share knowledge, inspire learners, and make an impact, you are in the right place.';
    if (t('langCode') === 'fr') {
        InstHeadTitle = "Réalisez votre rêve de transmettre le savoir avec Acumen Glow";
        InstHeadContent = "Chez Acumen Glow, nous croyons au pouvoir transformateur de l’éducation et recherchons des formateurs passionnés comme vous pour guider cette mission. Si vous souhaitez partager vos connaissances, inspirer les apprenants et avoir un réel impact, vous êtes au bon endroit.";
    }
    if (t('langCode') === 'pt') {
        InstHeadTitle = "Realize o Seu Sonho de Capacitar Através da Aprendizagem com a Acumen Glow";
        InstHeadContent = "Na Acumen Glow, acreditamos no poder transformador da educação e estamos à procura de formadores apaixonados como você para liderar esta jornada. Se está motivado para partilhar conhecimento, inspirar aprendentes e causar impacto, está no lugar certo.";
    }
        // const JoinTitle =
    //     'Your dream to leave a legacy in this world is just a click away...<br />Join our instructor team! ';
    // const StartTeachTitle = 'Start teaching the world today';
    // const JoinContent1 =
    //     'Our platform is designed to guide you from step 1 upto creation of a perfect, valuable program that will leave your mark on each of your students. Our expertise is not just in training you to create the best courses, but also in amplifying your reach exponentially so that your knowledge reaches the global population. ';
    // const JoinContent2 =
    //     'Over time, we have touched the lives of more than a million students with multiple life enhancing courses and wants each of our instructors to do the same and reap the abundant rewards with maximum protection of their intellectual rights. ';
    // const StartTeachContent =
    //     'If teaching is your passion, we are your solution. If you have the knowledge that will benefit others, then we are here to enrich your potential and support you to create world-class courses and make your world wide impact.<br /><br />Our platform is designed to guide you from step 1 upto creation of a perfect, valuable program that will leave your mark on each of your students. Our expertise is not just in training you to create the best courses but also in amplifying your reach exponentially so that your knowledge reaches the global population.<br /><br /> Over time, we have touched the lives of more than a million students with multiple life enhancing courses and wants each of our instructors to do the same and reap the abundant rewards with maximum protection of their intellectual rights.';
    const [drawer, drawerAction] = useToggle(false);

    return (
        <>
            <Drawer drawer={drawer} action={drawerAction.toggle} type="instructor" />
            <HeaderInstructor drawer={drawer} action={drawerAction.toggle} />
            <>
                <div style={{ background: '#f2e7e7' }}>
                    <div
                        className="container pt-80 pb-80 hideonmobile"
                        style={{
                            backgroundImage: `url(assets/img/insr_banner.png)`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                        }}
                    >
                        <div className="row m-0">
                            <div className="col-md-6">
                                <h3 className="mt-5 mb-5">{Parser(InstHeadTitle)}</h3>
                                <p style={{ textAlign: 'left' }}>{Parser(InstHeadContent)}</p>
                                <Link to="/instructor-register">
                                    <a className="main-btn mt-3 mb-4" href="/">
                                        Register Now
                                    </a>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ background: '#f2e7e7' }}>
                    <div
                        className="pt-40 pb-40 container hideondesktop"
                        style={{
                            backgroundImage: `url(/assets/img/insr_banner.png)`,
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                        }}
                    >
                        <div className="row m-0">
                            <div className="col-md-6">
                                <img
                                    alt=""
                                    src={`${IMGBASEAPIURL}instructor/insr_banner_mob.png?v=20230123`}
                                    style={{
                                        float: 'right',
                                        maxWidth: '120px',
                                        marginTop: '30px',
                                        marginLeft: '10px',
                                    }}
                                />
                                <h5 className="mt-4 mb-3">{Parser(InstHeadTitle)}</h5>
                                <p style={{ textAlign: 'left' }}>{Parser(InstHeadContent)}</p>
                                <Link to="/instructor-register">
                                    <a className="main-btn mt-3 mb-4" href="/">
                                        Register Now
                                    </a>
                                </Link>
                                <div style={{ clear: 'both' }}></div>
                            </div>
                        </div>
                    </div>
                </div>


                {t('langCode') === 'en' && (
                    <>
                        <div className="container pt-80 pb-80">
                            <div className="row">
                                <div className="col-md-12">
                                    <h2 className="text-center mb-10">Why Us?</h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="join_desc">
                                        <h4>Global Impact, Local Comfort</h4>
                                        <p>Teach learners worldwide from the comfort of your own space.</p>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="join_desc">
                                        <h4>Earn, Grow, Thrive</h4>
                                        <p>Unlock earning potential while building your brand as an educator.</p>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="join_desc">
                                        <h4>Simplified Teaching, Amplified Reach</h4>
                                        <p>Access advanced tools and a global audience to make teaching hassle-free and impactful.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <section
                            className="appie-instructor-area"
                            style={{ backgroundImage: `url(/assets/img/instructor-bg.jpg)` }}
                        >
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-7">
                                        <div className="appie-instructor-content">
                                            <h3>Your expertise deserves the best stage! </h3>
                                            <h4>Register today and take the first step towards transforming lives-starting with your own.</h4>
                                            <Link className="main-btn" to="/instructor-register">Get Started</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </>
                )}

                 {t('langCode') === 'fr' && (
                    <>
                        <div className="container pt-80 pb-80">
                            <div className="row">
                                <div className="col-md-12">
                                    <h2 className="text-center mb-10">Pourquoi nous rejoindre ?</h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="join_desc">
                                        <h4>Impact global, confort local</h4>
                                        <p>Enseignez à des apprenants du monde entierdepuisvotre propre espace.</p>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="join_desc">
                                        <h4>Gagnez, évoluez, réussissez</h4>
                                        <p>Développezvotrepotentiel de revenus tout enconstruisantvotreréputation de formateur.</p>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="join_desc">
                                        <h4>Enseignementfacilité, portéeamplifiée</h4>
                                        <p>Profitezd'outils performants et d'une audience internationale pour un enseignement simple et efficace.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <section
                            className="appie-instructor-area"
                            style={{ backgroundImage: `url(/assets/img/instructor-bg.jpg)` }}
                        >
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-7">
                                        <div className="appie-instructor-content">
                                            <h3>Votre expertise mérite la meilleure scène ! </h3>
                                            <h4>Inscrivez-vous dès aujourd'hui et faites le premier pas pour transformer des vies – à commencer par la vôtre.</h4>
                                            <Link className="main-btn" to="/instructor-register">Commencez maintenant</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </>
                )}

                 {t('langCode') === 'pt' && (
                    <>
                        <div className="container pt-80 pb-80">
                            <div className="row">
                                <div className="col-md-12">
                                    <h2 className="text-center mb-10">Porquê Escolher-nos?</h2>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="join_desc">
                                        <h4>Impacto Global, Conforto Local</h4>
                                        <p>Ensine alunos de todo o mundo a partir do conforto da sua casa.</p>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="join_desc">
                                        <h4>Ganhe, Cresça, Prospere</h4>
                                        <p>Aumente o seu potencial de rendimento enquanto constrói a sua marca como educador.</p>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="join_desc">
                                        <h4>Ensino Simplificado, Alcance Ampliado</h4>
                                        <p>Aceda a ferramentas avançadas e a uma audiência global para ensinar de forma eficaz e sem complicações.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <section
                            className="appie-instructor-area"
                            style={{ backgroundImage: `url(/assets/img/instructor-bg.jpg)` }}
                        >
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-7">
                                        <div className="appie-instructor-content">
                                            <h3>A sua experiência merece o melhor palco!</h3>
                                            <h4>Registe-se hoje e dê o primeiro passo para transformar vidas — a começar pela sua.</h4>
                                            <Link className="main-btn" to="/instructor-register">Começar Agora</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </>
                )}

            </>
            <Footer />
            <BackToTop />
        </>
    );
}

export default InstructorIndex;
